import { ContentfulPercentOffBanner } from '@jbhi-fi/apis/src/contentful/types';
import { PercentOffHtmlBannerProps } from '../../PercentOffHtmlBanner/PercentOffHtmlBanner';
import { ThemeTransformer } from './ThemeTransformer';
import { IconName } from '@jbhi-fi/lanyard-ui/components/Icon';

export abstract class PercentOffBannerTransformer {
  static toPercentOffHtmlBannerProps = (entry: ContentfulPercentOffBanner): PercentOffHtmlBannerProps => {
    return {
      percentOff: !Number.isNaN(Number(entry.fields.percentOffAmount)) ? Number(entry.fields.percentOffAmount) : 0,
      categoryName: entry.fields.categoryText,
      brandNames: entry.fields.brandLogos?.map(logo => `${logo}` as IconName) ?? [],
      disclaimer: entry.fields.disclaimer,
      endDate: entry.fields.endDate ? new Date(entry.fields.endDate) : undefined,
      url: entry.fields.url,
      displayShopNowButton: entry.fields.displayShopNowButton ?? false,
      theme: entry.fields.theme && ThemeTransformer.toContentThemePalette(entry.fields.theme),
      trackingData: {
        id: entry?.fields?.name ?? '',
        url: entry?.fields?.url,
        type: 'carousel',
      },
    };
  };
}
